import {
  MlggkProjectsEffectivenessExportDocument,
  type MlggkProjectsEffectivenessExportQuery,
  type MlggkProjectsEffectivenessExportQueryVariables,
  ProjectsEffectivenessExportDocument,
  type ProjectsEffectivenessExportQuery,
  type ProjectsEffectivenessExportQueryVariables,
  TriadProjectsEffectivenessExportDocument,
  type TriadProjectsEffectivenessExportQuery,
  type TriadProjectsEffectivenessExportQueryVariables,
} from "@src/__generated__/graphql";
import type { Store as ProjectListStore } from "@src/components/modules/projects/list/Store/Store";
import { FetchHelper } from "@src/helpers/apollo/fetch";
import { action, computed, makeObservable } from "mobx";

export class ProjectListNavbarStore {
  private readonly projectListStore: ProjectListStore;

  private readonly projectsEffectivenessFetcher = new FetchHelper<
    ProjectsEffectivenessExportQuery,
    ProjectsEffectivenessExportQueryVariables
  >(ProjectsEffectivenessExportDocument);

  private readonly mlggkProjectsEffectivenessFetcher = new FetchHelper<
    MlggkProjectsEffectivenessExportQuery,
    MlggkProjectsEffectivenessExportQueryVariables
  >(MlggkProjectsEffectivenessExportDocument);

  private readonly triadProjectsEffectivenessFetcher = new FetchHelper<
    TriadProjectsEffectivenessExportQuery,
    TriadProjectsEffectivenessExportQueryVariables
  >(TriadProjectsEffectivenessExportDocument);

  constructor(projectListStore: ProjectListStore) {
    makeObservable(this);
    this.projectListStore = projectListStore;
  }

  @computed
  get isProjectsEffectivenessExportDisabled(): boolean {
    return !this.projectListStore.appStore.workspaceStore.settings
      ?.exportSettings.project_effectiveness;
  }

  @computed
  get isMlggkProjectsEffectivenessExportDisabled(): boolean {
    return !this.projectListStore.appStore.workspaceStore.settings
      ?.exportSettings.mlggk_project_effectiveness;
  }

  @computed
  get isTriadProjectsEffectivenessExportDisabled(): boolean {
    return !this.projectListStore.appStore.workspaceStore.settings
      ?.exportSettings.triad_project_effectiveness;
  }

  @computed
  get isExporting(): boolean {
    return (
      this.projectsEffectivenessFetcher.isLoading.value ||
      this.mlggkProjectsEffectivenessFetcher.isLoading.value ||
      this.triadProjectsEffectivenessFetcher.isLoading.value
    );
  }

  @action.bound
  async exportProjectsEffectiveness(): Promise<void> {
    const [data] = await this.projectsEffectivenessFetcher.fetch({
      filters: this.projectListStore.queryVariables.filters,
    });

    if (!data?.projectsEffectivenessExport) return;

    window.location.href = data.projectsEffectivenessExport;
  }

  @action.bound
  async exportMlggkProjectsEffectiveness(): Promise<void> {
    const [data] = await this.mlggkProjectsEffectivenessFetcher.fetch({
      filters: this.projectListStore.queryVariables.filters,
    });

    if (!data?.mlggkProjectsEffectivenessExport) return;

    window.location.href = data.mlggkProjectsEffectivenessExport;
  }

  @action.bound
  async exportTriadProjectsEffectiveness(): Promise<void> {
    const [data] = await this.triadProjectsEffectivenessFetcher.fetch({
      filters: this.projectListStore.queryVariables.filters,
    });

    if (!data?.triadProjectsEffectivenessExport) return;

    window.location.href = data.triadProjectsEffectivenessExport;
  }
}
